
const ACCOUNT_ID_LOCALSTORAGE_KEY = "adblock-app-account-id-key";
const AUTH_TOKEN_LOCALSTORAGE_KEY = "adblock-app-auth-token-key";

const localStorageManagerForPrefix = (storagePrefix) => ({
    get: () => {
        // get the token by key @storagePrefix
        if (localStorage && typeof localStorage.getItem === "function") {
            const maybeToken = localStorage.getItem(storagePrefix);
            return maybeToken ? maybeToken : "";
        }
    },
    set: (data) => {
        // set the token by key at @storagePrefix
        if (localStorage && typeof localStorage.getItem === "function") {
            return localStorage.setItem(storagePrefix, data);
        }
    },
    getJSON: () => {
        // get the data at key @storagePrefix, returning JSON parsed result
        if (localStorage && typeof localStorage.getItem === "function") {
            const maybeToken = localStorage.getItem(storagePrefix);
            try {
                const parsed = JSON.parse(maybeToken);
                return parsed;
            } catch (err) {
                return {};
            }
        }
    },
    setJSON: (data) => {
        // set the data by key at @storagePrefix, stringifying the data
        if (localStorage && typeof localStorage.getItem === "function") {
            return localStorage.setItem(storagePrefix, JSON.stringify(data));
        }
    },
    remove: () => {
        // clear the token by key at @prefix
        if (localStorage && typeof localStorage.removeItem === "function") {
            localStorage.removeItem(storagePrefix);
            return true;
        }
        return false;
    },
});

export const authTokenLocalStorage = localStorageManagerForPrefix(AUTH_TOKEN_LOCALSTORAGE_KEY);
export const accountIdLocalStorage = localStorageManagerForPrefix(ACCOUNT_ID_LOCALSTORAGE_KEY);
